import { createContext } from 'react';
import initialNotificationsState from './initialNotificationsState';

const NotificationsContext = createContext(initialNotificationsState);

export default NotificationsContext;
